import Swiper from "swiper";
import { EffectFade, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const heroSlider = new Swiper(".hero-slider", {
    modules: [EffectFade, Autoplay],
    effect: "fade",
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    on: {
      init: function () {
        applyZoomEffect(this);
      },
      slideChange: function () {
        applyZoomEffect(this);
      },
    },
  });

  function applyZoomEffect(swiper) {
    const slides = swiper.slides;

    // Reset all slides
    slides.forEach((slide) => {
      slide.querySelector(".swiper-slide__img").style.transform = "scale(1)";
    });

    // Apply zoom effect to active slide
    const activeSlide = slides[swiper.activeIndex];
    if (activeSlide) {
      const img = activeSlide.querySelector(".swiper-slide__img");
      img.style.transition = "transform 4s ease-in-out";
      img.style.transform = "scale(1.1)";
    }
  }
});
